<template>
  <a class="logout" @click="logout">Logout</a>
</template>

<script>
export default {
  name: "Logout",
  methods: {
    logout() {
      this.$store.dispatch({ type: "userLogout" });
    }
  }
};
</script>
